<mat-drawer-container hasBackdrop class="drawer-container">
  <mat-drawer #drawer mode="over">
    <app-sidenav [drawer]="drawer"></app-sidenav>
  </mat-drawer>
  <div  id="drawer"></div>
  <app-header [drawer]="drawer"></app-header>
  <div class="container-app">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>

</mat-drawer-container>
